import React from 'react';

import { CrossIcon, DeleteIcon } from '@vlabs/icons';
import type { BulkActionsProps } from '@vlabs/uikit';
import { BulkActions, Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import st from './CardsBulkActions.module.sass';

export interface CardsBulkActionsProps extends BulkActionsProps {
  selectedCount: number;
  onDelete?: VoidFunction;
  onCancel?: VoidFunction;
}

function CardsBulkActions({
  selectedCount,
  onCheckboxClick,
  onCancel = undefined,
  onDelete = undefined,
  indeterminate = false,
}: CardsBulkActionsProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <BulkActions
      data-testid="CardsBulkActions"
      indeterminate={indeterminate}
      onCheckboxClick={onCheckboxClick}
    >
      <div className={st.Root}>
        <span
          className={st.SelectedCardsCount}
          data-testid="CardsBulkActions-SelectedCount"
        >
          {t('card-list-page:bulk actions.selected count', { count: selectedCount })}
        </span>
        <div className={st.Controls}>
          {!!onDelete && (
            <Control.Button
              data-testid="CardsBulkActions-DeleteBtn"
              icon={<DeleteIcon />}
              kind="negative"
              onClick={onDelete}
              variant="flat-inverted"
            >
              {t('card-list-page:bulk actions.delete')}
            </Control.Button>
          )}
          {!!onCancel && (
            <Control.IconButton
              data-testid="CardsBulkActions-CancelBtn"
              icon={<CrossIcon />}
              kind="secondary"
              onClick={onCancel}
              shape="square"
              variant="flat-inverted"
            />
          )}
        </div>
      </div>
    </BulkActions>
  );
}

export { CardsBulkActions };
